export default __webpack_public_path__ + "static/O0100-889ad076d1b20462cee25961e9d9b60b.png";